import { axios } from "../../../lib/axios";

export const getCategories = async () => {
  const response = await axios.get(`/categories`);
  // console.log(response.data);

  return response.data;
};
